import { ws } from "../../../utils/common";

export const getVolunteerOfAssociationWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user-association/volunteer/",
    { id_association },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getEventsOfAssociationWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/association/" + id_association,
    { only_active: true },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const getVolunteerSubscribedEventWS = async ({ id_event }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event/volunteer/" + id_event,
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const postNotificationToGroupWS = async ({
  title,
  body,
  user,
  id_event,
  id_association,
}) => {
  const data = {
    user,
    body,
    title,
  };

  if (id_event) data.id_event = id_event;
  else data.id_association = id_association;

  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "notification/",
    null,
    data,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data.message;
  }
};
